module.exports = __webpack_public_path__ + "img/icon5.baab29bf.baab29bf.svg";